module.exports = __webpack_public_path__ + "static/media/manuals.8e2b56d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/symbols/manuals.svg
// module id = 1476
// module chunks = 0